import React from 'react'
import './styles/style.sass'
import { Provider as ReduxProvider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'
import AppRouter from './components/containers/AppRouter'
import createStore from './redux/store'
import { Slide, ToastContainer } from 'react-toastify'

export const { store, persistor } = createStore()

const App = () => {

  const renderToastContainer = () => (
    <ToastContainer
      position="top-right"
      autoClose={3000}
      hideProgressBar
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      transition={Slide}
    />
  )

  return (
    <ReduxProvider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <AppRouter />
      </PersistGate>
      {renderToastContainer()}
    </ReduxProvider>
  )
}

export default App

